<template>
  <card>
    <h2 class="mt-2"> Welcome to Incentify! </h2>
      <br><br>
      <div class="row">
        <div class="col-6">
          To get started: <button class="btn btn-primary" @click="goToSetup()">Go to Setup</button>
          <br><br><br>
        </div>
        <div class="col-5">
          <h5>Summary of what's needed:</h5>
          <div>
            <ul>
              <li><b>Account information:</b> <i :class="'ml-2 ' + icon(accountInformation)"/>
                <!-- <ul>
                  <li>Company Name: <i :class="icon(companyName)"/></li>
                  <li>Contact Email: <i :class="icon(email)"/></li>
                  <li>Address: <i :class="icon(address)"/></li>
                  <li>City: <i :class="icon(city)"/></li>
                  <li>Country: <i :class="icon(country)"/></li>
                  <li>State/Province: <i :class="icon(state)"/></li>
                  <li>postalCode: <i :class="icon(postalCode)"/></li>
                  <li>fiscal Year Start: <i :class="icon(fiscalYearStart)"/></li>
                </ul> -->
              </li>
              <li><b>Spiffs & Leads:</b> <i :class="'ml-2 ' + icon(spiffLeads)"/>
                <!-- <ul>
                  <li>Define how you want to spiff and track leads: <i :class="icon(manageLeadsMode)"/></li>
                </ul> -->
              </li>
              <!-- <li><b>Create 1+ Affiliate Company:</b> <i :class="'ml-2 ' + icon(affiliateCompanyCreated)"/> </li>
              <li><b>Create 1+ Affiliate:</b> <i :class="'ml-2 ' + icon(affiliateCreated)"/> </li> -->
            </ul>
          </div>
        </div>
      </div>
      <br>
  </card>
</template>

<script>
export default {
    name: 'Welcome-Card',
    methods: {
      icon (status) {
        return status ? 'fas fa-check text-success' : 'fas fa-check text-light-gray'
      },
      accountProfileAvailable () { return !!this.$store.getters.accountProfile },
      spiffLeadsDataAvailable () { return !!this.$store.getters.spiffsLeadsSetup },
      goToSetup () {
        this.$router.push({path: '/admin/setup'})
      }
    },
    computed: {
      accountInformation () {
        return this.$store.getters.isAccountProfileComplete && this.$store.getters.isAccountSetupComplete
      },
      spiffLeads () {
        return this.$store.getters.isSpiffsLeadsSetupComplete
      },
      affiliateCompanyCreated () { return this.$store.getters.companies.length > 0 },
      affiliateCreated () { return this.$store.getters.affiliates.length > 0 },
    },
}
</script>

<style>

</style>